import React, { Component } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import PropTypes from 'prop-types';
import Chat from '../../views/Chat';
import "./DefaultLayout.scss";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultAside extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTab: '1',
    };
  }

  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <TabContent className="full-height" activeTab={this.state.activeTab}>
          <TabPane className="full-height" tabId="1">
            <Chat />
          </TabPane>
        </TabContent>
      </React.Fragment>
    );
  }
}

DefaultAside.propTypes = propTypes;
DefaultAside.defaultProps = defaultProps;

export default DefaultAside;
